import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import './AboutUsStyle.scss';
import CalculatorModal from '../job-details/CalculatorModal';

import calculator_icon from '../../assets/images/price-calculator.png';
import about_thubm from '../../assets/images/about-thum-01.jpg';

import work_icon_01 from '../../assets/images/why-work-icon01.png';
import work_icon_02 from '../../assets/images/why-work-icon02.png';
import work_icon_03 from '../../assets/images/why-work-icon03.png';
import work_icon_04 from '../../assets/images/why-work-icon04.png';
import work_icon_05 from '../../assets/images/why-work-icon05.png';

import team_01 from '../../assets/images/team-1.jpg';
import team_02 from '../../assets/images/team-2.jpg';
import team_03 from '../../assets/images/team-3.jpg';

const AboutUsView = (props) => {
  return (
    <>
      {/* cc search section open */}

      <section className="findjob-search-section">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-md-3 findjob-search-heading">
              <h2 className="cc-main_title--md">Find a job</h2>
            </div>
            <div className="col-md-8 findjob-search-bar">
              <div className="cc-searchbar">
                <div className="srch-fld-row">
                  <div className="srch-fld-col">
                    <input type="text" placeholder="Postcode" />
                  </div>
                  <div className="srch-fld-col">
                    <select>
                      <option>Select Profession</option>
                      <option>Doctor</option>
                    </select>
                  </div>
                  <div className="srch-fld-col srch-btn-col">
                    <input type="submit" value="" className="form-submit-btn" />
                  </div>
                </div>
              </div>
              <h5 className="job-search-info">
                List of Jobs will apear based on the postcode given by user
              </h5>
            </div>
          </div>
        </div>
        <a href="" onClick={props.showCalculator} className="cc-pric-calc-icon">
          <img src={calculator_icon} alt="" />
        </a>
      </section>

      {/* cc search section closed */}

      {/* about us start */}
      <section className="about-us pd-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="cc-main_title">
                About <span className="highlighted">Us</span>
              </h2>
            </div>
            <div className="col-lg-6">
              <p>{props.about_us.description}</p>
            </div>
            <div className="col-lg-6">
              <img src={about_thubm} alt="" />
            </div>
          </div>
        </div>
      </section>
      {/* about us end */}

      {/* make us start */}
      <section className="make-us common-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="top-txt">
                <h2 className="cc-main_title">
                  What Makes <span className="highlighted">Us Different?</span>
                </h2>
                <p>{props.what_make_us_different.description}</p>
              </div>
            </div>
          </div>
          <div className="row">
            {props.what_make_differences.map((what_make_differences, index) => (
              <div className="col-md-6 col-lg-4">
                <div className="item-box">
                  <div className="icon">
                    <img src={what_make_differences.difference_image} alt="" />
                  </div>
                  <div className="title">{what_make_differences.title}</div>
                  <p>{what_make_differences.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* make us end */}

      {/* meet our team start */}
      <section className="meet-our-team common-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="cc-main_title">
                Meet <span className="highlighted">Our Team</span>
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <Carousel className="our-team-carousel" indicators={false}>
                <Carousel.Item>
                  {console.log('props.team_member', props.team_member)}
                  {props.team_member.map((person, index) => (
                    <div className="box">
                      <div className="content">
                        <div className="pic">
                          <img src={person.person_image} alt="" />
                        </div>
                        <h4>
                          {person.first_name} {person.last_name}
                        </h4>
                        <h5>{person.designation}</h5>
                        <div className="txt"></div>
                        <a href="" className="btn-apply">
                          Apply <i className="fa fa-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                  ))}
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
        </div>
      </section>
      {/* meet our team end */}
      <CalculatorModal
        modal_show={props.modal_show}
        hideCalculator={props.hideCalculator}
      />
    </>
  );
};

export default AboutUsView;
